export default __webpack_public_path__ + "2649ea00eec65a0e195eea47b6511142.png";